import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SetComponentLanguage } from '../../../helpers';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import LocalizedStrings from 'react-localization';
import en from './locales/en.json';
import fr from './locales/fr.json';
import './SuccessModal.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class SuccessModal extends Component {
	render() {
	  	return (
			<div>
		  		<Modal isOpen={this.props.isModalSuccessOpen} toggle={this.props.toggleSuccessModal}>
		          	<ModalHeader toggle={this.props.toggleSuccessModal}>{strings.title}</ModalHeader>
		          	<ModalBody>
		            	{strings.description}
		          	</ModalBody>
		          	<ModalFooter className="justify-content-center">
		            	<button 
		            		type="submit" 
		            		className="showtix-button showtix-background__primary-3"
                            onClick={this.props.toggleSuccessModal}
		            		>{strings.ok}</button>
		          	</ModalFooter>
		        </Modal>
			</div>
	  	);
	}
}

SuccessModal.propTypes = {
    isModalSuccessOpen: PropTypes.bool,
    toggleSuccessModal: PropTypes.func
}

export default SuccessModal;


// WEBPACK FOOTER //
// ./src/components/Checkin/SuccessModal/SuccessModal.js